import {LiveChecksStatusBadge} from '@github-ui/commit-checks-status/LiveChecksStatusBadge'
import {useMemo} from 'react'
import {StatusCheckState, type StatusCheckRollup} from './types/list-types'

interface PullsChecksStatusBadgeProps {
  headSha: string
  repositoryNwo: string
  statusCheckRollup: StatusCheckRollup
  aliveChannel?: string | null
}

function mapStatusStateToRollup(state: StatusCheckState): 'success' | 'failure' | 'pending' {
  switch (state) {
    case StatusCheckState.Success:
      return 'success'
    case StatusCheckState.Failure:
      return 'failure'
    case StatusCheckState.Pending:
      return 'pending'
    default:
      return 'pending'
  }
}

export function PullsChecksStatusBadge({
  headSha,
  repositoryNwo,
  statusCheckRollup,
  aliveChannel,
}: PullsChecksStatusBadgeProps) {
  const [ownerLogin = '', name = ''] = repositoryNwo.split('/')
  const repo = useMemo(() => ({ownerLogin, name}), [ownerLogin, name])

  const descriptionText = `${statusCheckRollup.successCount}/${statusCheckRollup.totalCount}`

  return (
    <LiveChecksStatusBadge
      oid={headSha}
      statusRollup={mapStatusStateToRollup(statusCheckRollup.state)}
      repo={repo}
      aliveChannel={aliveChannel}
      size="small"
      variant="default"
      descriptionText={descriptionText}
    />
  )
}
